import React from "react";
import { motion } from "framer-motion";
import { Check, Target, Eye } from "lucide-react";
import { PRINCIPIOS, METODOLOGIA, IMAGES } from "../../data";

export default function QuienesSomos() {
  return (
    <section id="quienes" className="py-20 lg:py-28 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          {/* Misión / visión / principios */}
          <div className="lg:col-span-7">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-espana-red mb-3">
              Quiénes somos
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight leading-tight">
              Un proyecto independiente, abierto y basado en datos.
            </h2>
            <p className="mt-5 text-lg text-gray-600 leading-relaxed">
              E² reúne ideas para modernizar la Administración, fortalecer las
              instituciones y mejorar la vida de los ciudadanos, siempre desde el
              respeto a la Constitución y al Estado de derecho.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-5">
              <div className="bg-white border border-gray-200 p-6">
                <Target className="text-espana-red mb-3" size={24} />
                <h3 className="font-bold mb-1">Nuestra misión</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Una gestión pública más eficiente, transparente y cercana, que
                  use con responsabilidad cada euro de los contribuyentes.
                </p>
              </div>
              <div className="bg-white border border-gray-200 p-6">
                <Eye className="text-espana-red mb-3" size={24} />
                <h3 className="font-bold mb-1">Nuestra visión</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Instituciones que recuperan la confianza mediante ejemplaridad,
                  transparencia y decisiones basadas en datos y resultados.
                </p>
              </div>
            </div>

            <h3 className="mt-10 font-bold text-lg">Nuestros principios</h3>
            <ul className="mt-4 grid sm:grid-cols-2 gap-x-6 gap-y-3">
              {PRINCIPIOS.map((p) => (
                <li key={p} className="flex items-start gap-2 text-gray-700">
                  <Check size={18} className="text-espana-gold mt-0.5 shrink-0" strokeWidth={3} />
                  <span className="text-sm">{p}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Metodología */}
          <div id="metodologia" className="lg:col-span-5">
            <div className="relative mb-6">
              <img
                src={IMAGES.documents}
                alt="Elaboración y análisis de documentos de política pública"
                className="w-full h-52 object-cover"
              />
              <span className="absolute bottom-0 left-0 h-1.5 w-24 bg-espana-red" />
            </div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-espana-red mb-3">
              Metodología — cómo elaboramos los Policy Briefs
            </p>
            <p className="text-sm text-gray-600 mb-6 leading-relaxed">
              Sin nombre propio, la confianza se gana con transparencia de método.
              Este es el proceso detrás de cada documento.
            </p>
            <ol className="space-y-4">
              {METODOLOGIA.map((m, i) => (
                <motion.li
                  key={m.step}
                  initial={{ opacity: 0, x: 16 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                  data-testid={`metodologia-${m.step}`}
                  className="flex gap-4 bg-white border border-gray-200 p-5"
                >
                  <span className="text-2xl font-black text-espana-gold leading-none">
                    {m.step}
                  </span>
                  <div>
                    <h4 className="font-bold">{m.title}</h4>
                    <p className="text-sm text-gray-600 mt-1 leading-relaxed">{m.text}</p>
                  </div>
                </motion.li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
